<ng-container *ngIf="layoutModelsLoaded">
  <app-page-header [componentModel]="componentModel"
   (saveButtonClicked)="submit()" [showCancel]="true"
    [showSecondary]="false" [submitButtonDisabled]="!formGroup.dirty || submitting"
     [showLanguage]="model !== 'attribute-set' && model !== 'language'"
    (languageChanged)="languageChanged($event)">
  </app-page-header>
  <nz-row>
    <div class="container" nz-col nzXs="24" nzMd="22">
   <app-brand #formComponent *ngIf="model === 'brand'" [formGroup]="formGroup" [mode]="mode"
        [componentModel]="componentModel" (submitChanges)="submit()"></app-brand>
      <app-language #formComponent *ngIf="model === 'language'" [formGroup]="formGroup" [mode]="mode"
        (submitChanges)="submit()">
      </app-language>
      
      <app-display-group #formComponent *ngIf="model === 'display-properties'" [formGroup]="formGroup" [mode]="mode"
        (submitChanges)="submit()">
      </app-display-group>
      <app-product-status #formComponent *ngIf="model === 'product-status'" [formGroup]="formGroup" [mode]="mode"
        (submitChanges)="submit()">
      </app-product-status>
      <app-manufacturer #formComponent *ngIf="model === 'manufacturer'" [formGroup]="formGroup" [mode]="mode"
        (submitChanges)="submit()"></app-manufacturer>
      <app-currency #formComponent *ngIf="model === 'currency'" [formGroup]="formGroup" [mode]="mode"
        (submitChanges)="submit()">
      </app-currency>
      <app-attribute-group #formComponent *ngIf="model === 'attribute-group'" [formGroup]="formGroup" [mode]="mode"
        (submitChanges)="submit()">
      </app-attribute-group>
      <app-attribute-set #formComponent *ngIf="model === 'attribute-set'" [formGroup]="formGroup" [mode]="mode"
        (submitChanges)="submit()">
      </app-attribute-set> 


      <app-attribute #formComponent *ngIf="model === 'attribute'"
        [formGroup]="formGroup"
        [languageId]="selectedLanguage" [mode]="mode" [componentModel]="componentModel" (submitChanges)="submit()">
      </app-attribute>

      
      <app-tag #formComponent *ngIf="model === 'tag'" [formGroup]="formGroup" [mode]="mode" (submitChanges)="submit()">
      </app-tag>
      <app-relationship #formComponent *ngIf="model === 'relationship'" [formGroup]="formGroup" [mode]="mode" (submitChanges)="submit()">
      </app-relationship>
      <app-form-category #formComponent *ngIf="model === 'category'" [formGroup]="formGroup" [mode]="mode"
        [componentModel]="componentModel" (submitChanges)="submit()"></app-form-category> 
    </div>
  </nz-row>
</ng-container>
